import { __awaiter } from "tslib";
import { ButtonType, MessageType } from '@getaccept/fried-tofu';
import { defineComponent, onMounted, ref } from 'vue';
import LoginSignupContainer from '@getaccept/lib-shared-new/src/login-signup/components/LoginSignupContainer.vue';
import { CreateEntityHelper } from '../../helpers/create-entity.helper';
import { TimezoneHelper } from '../../helpers/timezone.helper';
import { DatacenterHelper } from '../../helpers/datacenter.helper';
import CreateEntityForm from './CreateEntityForm.vue';
export default defineComponent({
    name: 'CreateEntity',
    components: {
        CreateEntityForm,
        LoginSignupContainer,
    },
    props: {
        isSignup: { type: Boolean, default: false },
        userId: { type: String, default: '' },
        entityName: { type: String, default: '' },
        entityCountryCode: { type: String, default: '' },
    },
    setup(props) {
        const loading = ref(false);
        const error = ref(null);
        const initialFormData = ref(null);
        const handleCancel = () => {
            window.location.href = '/dashboard';
        };
        const handleSubmit = (formData) => __awaiter(this, void 0, void 0, function* () {
            try {
                loading.value = true;
                yield CreateEntityHelper.createEntity(formData);
                CreateEntityHelper.trackSignupSuccess(props.isSignup, props.userId, formData);
            }
            catch (e) {
                error.value = e;
                CreateEntityHelper.trackSignupError(error.value);
            }
            finally {
                loading.value = false;
            }
        });
        const setInitialFormData = () => __awaiter(this, void 0, void 0, function* () {
            const geoLocation = yield CreateEntityHelper.getGeoLocation();
            const timezone = TimezoneHelper.getTimezoneAsString();
            const countryCode = props.entityCountryCode || geoLocation.country_code || 'US';
            const datacenter = DatacenterHelper.getDatacenterFromCountry(countryCode).id;
            initialFormData.value = {
                name: props.entityName || '',
                countryCode,
                timezone,
                datacenter,
            };
        });
        onMounted(() => {
            setInitialFormData();
        });
        return {
            ButtonType,
            MessageType,
            loading,
            error,
            initialFormData,
            setInitialFormData,
            handleCancel,
            handleSubmit,
        };
    },
});
